module.exports = __webpack_public_path__ + "static/media/EQ_device_mocks02.7c5296d2.png";